/***
 * Created on 2023/7/19
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/


import React, {useState} from 'react';

export function useOnChange(inputValues) {
    const [values, setValues] = useState(inputValues);

    const onChange = (e, callback, name=null, value=null) => {
        if (callback && typeof callback === 'function') {
            callback(e);
        }
        const _name = name ? name : e.target.name;
        const _value = value ? value: e.target.value;
        setValues(prev => {
            return {
                ...prev,
                [_name]: _value
            }
        })
    }

    return {onChange, values, setValues};
};
